module.exports = __webpack_public_path__ + "media/images/logo_small-5c528596c6f61cc53603810448e0d1d2.png";